import { AccordionModule } from '@monorepo-channels/components/ui-common'
import { CUSTOM_ELEMENTS_SCHEMA, Component, OnInit, inject } from '@angular/core'
import { CommonModule, Location } from '@angular/common'

import { ActivatedRoute, Router } from '@angular/router'
import {
	getCheckinAvailabilities,
	getClient,
	getSelectedVenue,
	isLoadingSelectedVenue,
	VenueActions,
	VenueDetail,
} from '@monorepo-channels/channels/domain'
import { Store } from '@ngrx/store'
import { DataLayerService, isMobile, MenuOpened, OptimizeImage } from '@monorepo-channels/shared/util-helpers'
import { MatIconModule } from '@angular/material/icon'
import { MatButtonModule } from '@angular/material/button'
import { filter, take } from 'rxjs'
import { SwiperUiComponent } from '@monorepo-channels/components/ui-porto-bank'
import { MatDialog } from '@angular/material/dialog'
import {
	CheckinDisabledComponent,
	CheckinUnavailableComponent,
	LoginOrSignupComponent,
	ReservationDisabledComponent,
} from '@monorepo-channels/components/feature-porto-bank'

@Component({
	standalone: true,
	imports: [
		CommonModule,
		OptimizeImage,
		SwiperUiComponent,
		MatIconModule,
		AccordionModule,
		// FooterButtonsComponent,
		MatButtonModule,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	templateUrl: './venue-details.page.html',
	styleUrls: ['./venue-details.page.scss'],
})
export class VenueDetailsPageComponent implements OnInit {
	private store = inject(Store)
	public menuOpened = inject(MenuOpened)
	private activatedRoute = inject(ActivatedRoute)
	private router = inject(Router)
	private route = inject(ActivatedRoute)
	public location = inject(Location)
	venueDetail$ = this.store.select(getSelectedVenue)
	loadingVenue$ = this.store.select(isLoadingSelectedVenue)
	availabilitiesCheckin$ = this.store.select(getCheckinAvailabilities)
	client$ = this.store.select(getClient)
	openSection: 'horarios' | 'info' | 'beneficios' | 'checkin' | null = null
	public dialog = inject(MatDialog)
	isMobile = isMobile()
	private dataLayerService = inject(DataLayerService)

	ngOnInit(): void {
		const venueId = this.activatedRoute.snapshot.paramMap.get('venueId')
		venueId && this.store.dispatch(VenueActions.loadOneVenue({ venueId }))
		this.dataLayerService.logEvent({
			event: 'screen_view',
			screen_name: 'Gastronomia Porto Bank - Restaurante',
			venueId: venueId,
		})

		this.venueDetail$
			.pipe(
				filter((venueDetail): venueDetail is VenueDetail => !!venueDetail),
				take(1)
			)
			.subscribe(venueDetail => {
				if (!venueDetail) return
			})
	}

	toggleAccordion(section: 'horarios' | 'info' | 'beneficios' | 'checkin') {
		this.openSection = this.openSection === section ? null : section
	}

	onCheckinClick(venueDetail: VenueDetail) {
		if (venueDetail.checkin.status === 'disabled') {
			this.dialog.open(CheckinDisabledComponent, {
				data: {
					venueId: venueDetail._id,
				},
				width: '400px',
			})
			return
		}
		if (venueDetail.checkin.status === 'unavailable') {
			this.dialog.open(CheckinUnavailableComponent, {
				data: { checkin: venueDetail.checkin, venueId: venueDetail._id },
				width: '400px',
				maxHeight: '80vh',
			})
			return
		}
		this.client$.pipe(take(1)).subscribe(client => {
			if (!client) {
				this.dialog.open(LoginOrSignupComponent, {
					width: '400px',
				})
				return
			}
			this.router.navigate(['checkin'], { relativeTo: this.route })
		})
		return
	}

	onReservationClick(venueDetail: VenueDetail) {
		if (!venueDetail.reservation?.enabled) {
			this.dialog.open(ReservationDisabledComponent, {
				width: '400px',
				maxHeight: '80vh',
			})
			return
		}
		this.client$.pipe(take(1)).subscribe(client => {
			if (!client) {
				this.dialog.open(LoginOrSignupComponent, {
					width: '400px',
				})
				return
			}
			this.router.navigate(['reserva'], { relativeTo: this.route })
		})
		return
	}

	getFirstDay(venue: VenueDetail): string {
		const keys = Object.keys(venue.operationHours.dayTranslation)
		return venue.operationHours.dayTranslation[keys[0]]
	}

	getLastDay(venue: VenueDetail): string {
		const keys = Object.keys(venue.operationHours.dayTranslation)
		return venue.operationHours.dayTranslation[keys[keys.length - 1]]
	}

	formatHour(time?: string | null): string {
		if (!time) return ''
		return time.slice(0, 5).replace(':', 'h')
	}
}
